<forge-menu [options]="menuOptions" (forge-menu-select)="onForgeMenuItemSelect($event)" (forge-menu-open)="menuOpened($event)">
    <forge-icon-button [disabled]="disabled" [dense]="dense" aria-label="Actions menu">
        <forge-icon [name]="icon"></forge-icon>
        <forge-tooltip position="bottom">Actions menu</forge-tooltip>
    </forge-icon-button>
</forge-menu>